import CategoryForm from '../../components/Forms/CategoryForm';
import { invalidUrlError, validateUrl } from '../../utils/functions';

const OrganizationForm = ({ functionality }) => {
  const category = 'organization';
  const fields = [
    { name: 'name', label: 'Organization Name', type: 'text', required: true },
    {
      name: 'website',
      label: 'Organization URL',
      type: 'text',
      required: true,
      placeholder: 'https://usc.edu',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'type',
      label: 'Type',
      type: 'select',
      drop_down: true,
      required: true,
      options: [
        { value: 'Profit', label: 'Profit' },
        { value: 'Non Profit', label: 'Non Profit' },
        { value: 'University', label: 'University' },
        { value: 'Governmental', label: 'Governmental' },
        { value: 'NGO', label: 'NGO' },
        { value: 'Other', label: 'Other' },
      ],
    },
    { name: 'location', label: 'Headquarters Location', type: 'text', required: true },
    {
      name: 'contact_information',
      label: 'Contact Information',
      type: 'text',
      required: true,
      text_area: true,
      placeholder: 'Person, email, phone',
    },
    {
      name: 'mission_statement',
      label: 'Mission Statement/Focus Area',
      type: 'text',
      text_area: true,
    },
    { name: 'activities', label: 'Key Activities or Projects', type: 'text', text_area: true },
    {
      name: 'leadership',
      label: 'Leadership',
      type: 'text',
      placeholder: 'https://usc.edu/leadership',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    { name: 'notes', label: 'Additional Notes', type: 'text', text_area: true },
    { name: 'image_url', label: 'Organization Logo', type: 'image' },
  ];

  return <CategoryForm category={category} fields={fields} functionality={functionality} />;
};
export default OrganizationForm;
